module.exports = __webpack_public_path__ + "img/ember.ccb7e6a2.svg";